module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/bg_mv2512-pc-83da634ebceeb7e6f865f43ba3970da5.jpg";